import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/Login.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/no-subject",
    name: "no-Subject",
    component: () => import("../views/Nosubject.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/class/:section",
    name: "class",
    component: () => import("../views/Dashboard.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/class/:section/video/:id",
    name: "class-video",
    component: () => import("../views/dashboard/Video.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/class/:section/youtube/:id",
    name: "class-youtube",
    component: () => import("../views/dashboard/Youtube.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/class/:section/pdf/:id",
    name: "class-pdf",
    component: () => import("../views/dashboard/Pdf.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/class/:section/quiz/:quiz",
    name: "class-quiz",
    component: () => import("../views/dashboard/Quiz.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/class/:section/quiz/:quiz/result",
    name: "class-quiz-result",
    component: () => import("../views/dashboard/QuizResult.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/class/:section/quiz/:quiz/answer",
    name: "class-quiz-answer",
    component: () => import("../views/dashboard/QuizAnswer.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/class/:section/forum",
    name: "class-forum",
    component: () => import("../views/dashboard/Forum.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/class/:section/forum/:id",
    name: "class-forum-details",
    component: () => import("../views/dashboard/ForumDetails.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/notif",
    name: "notif",
    component: () => import("../views/dashboard/Notif.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/forum",
    name: "forum",
    component: () => import("../views/dashboard/Forum.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/forum/:id",
    name: "forum-details",
    component: () => import("../views/dashboard/ForumDetails.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  },
  {
    path: "/tryout/:tryout",
    name: "tryout",
    component: () => import("../views/Tryout.vue"),
    meta: {
      layout: "tryout-layout"
    }
  },
  {
    path: "/tryout/:tryout/package/:package",
    name: "tryout-start",
    component: () => import("../views/TryoutQuestion.vue"),
    meta: {
      layout: "tryout-layout"
    }
  },
  {
    path: "/tryout/result/:result",
    name: "tryout-result",
    component: () => import("../views/TryoutResult.vue"),
    meta: {
      layout: "tryout-layout"
    }
  },
  {
    path: "/tryout-history",
    name: "tryout-history",
    component: () => import("../views/TryoutHistory.vue"),
    meta: {
      layout: "tryout-layout"
    }
  },
  {
    path: "/exam",
    name: "exam",
    component: () => import("../views/dashboard/Exam.vue"),
    meta: {
      layout: "dashboard-layout"
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
